export default __webpack_public_path__ + "static/char-s-05-cht-d7431ab33b6f8d77c50664563b193735.png";